import { baseURL, getIdToken } from "./client";

import axios from "axios";

const authHeaders = async () => ({
  Authorization: `bearer ${await getIdToken()}`,
});

// GET /api/v1/tats  (Dev Admin only). clientUid is required.
// `page` is 1-based on the server. Response: { tats: [...], count }
export const listTats = async ({
  clientUid,
  pickupPincode,
  destinationPincode,
  page,
  pageSize,
}) => {
  const params = { clientUid };
  if (pickupPincode) params.pickupPincode = pickupPincode;
  if (destinationPincode) params.destinationPincode = destinationPincode;
  if (page) params.page = page;
  if (pageSize) params.pageSize = pageSize;
  return axios({
    baseURL,
    url: "/tats",
    headers: await authHeaders(),
    params,
  }).then(response => response.data);
};

// POST /api/v1/tats -> 201 { tat }. 409 when the pincode pair already exists.
export const createTat = async ({
  clientUid,
  pickupPincode,
  destinationPincode,
  tatDays,
  metadata,
}) =>
  axios({
    baseURL,
    url: "/tats",
    method: "POST",
    headers: await authHeaders(),
    data: { clientUid, pickupPincode, destinationPincode, tatDays, metadata },
  }).then(response => response.data);

// PATCH /api/v1/tats/:id -> { tat }. Only tatDays / metadata are mutable.
export const updateTat = async (id, { tatDays, metadata }) =>
  axios({
    baseURL,
    url: `/tats/${encodeURIComponent(id)}`,
    method: "PATCH",
    headers: await authHeaders(),
    data: { tatDays, metadata },
  }).then(response => response.data);

// DELETE /api/v1/tats/:id -> 204. HARD delete.
export const deleteTat = async id =>
  axios({
    baseURL,
    url: `/tats/${encodeURIComponent(id)}`,
    method: "DELETE",
    headers: await authHeaders(),
  }).then(response => response.data);

// POST /api/v1/tats/upload?clientUid= (multipart field "tats").
// Response: { inserted, updated, errors: [{ row, reason }] } (row 1 = header).
export const uploadTatsCsv = async (file, clientUid) => {
  const data = new FormData();
  data.append("tats", file, file.name);
  return axios({
    baseURL,
    url: "/tats/upload",
    method: "POST",
    headers: {
      ...(await authHeaders()),
      "Content-Type": "multipart/form-data",
    },
    params: { clientUid },
    data,
  }).then(response => response.data);
};
